import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { ClippingPanelComponent } from './clipping-panel/clipping-panel.component';
import { LayersPanelComponent } from './layers-panel/layers-panel.component';
import { MeasurementsPanelComponent } from './measurements-panel/measurements-panel.component';
import { SettingsPanelComponent } from './settings-panel/settings-panel.component';

@Component({
  selector: 'app-sidebar',
  imports: [
    CommonModule,
    SettingsPanelComponent,
    MeasurementsPanelComponent,
    ClippingPanelComponent,
    LayersPanelComponent,
    TranslocoPipe,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  activePanel = signal<'settings' | 'measurements' | 'clipping' | 'layers' | null>(null);

  @Output() profile2DClick = new EventEmitter<{ event: unknown; id: string }>();

  selectPanel(panel: 'settings' | 'measurements' | 'clipping' | 'layers'): void {
    // If clicking the same panel, toggle it off, otherwise switch to the new panel
    if (this.activePanel() === panel) {
      this.activePanel.set(null);
    } else {
      this.activePanel.set(panel);
    }
  }

  onProfile2DClick(event: unknown, id: string): void {
    this.profile2DClick.emit({ event, id });
  }
}
